import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { BlogLangType } from '../../../types/blogTypes';
import Box from '../../uikit/Box';
import Frame from '../../uikit/Frame';
import BlogPostList from './BlogPostList';
import { useBlogContext } from '../BlogProvider';
import { useBlogTrans } from '../../blogHooks/useBlogTrans';
import BlogMetaHeader from '../BlogMetaHeader';
import BlogJsonld from '../BlogJsonld';
import { useMemo } from 'react';

class ViewStore {
    constructor(lang: BlogLangType | undefined, category: string | undefined) {
        makeAutoObservable(this);
    }
}

const BlogPostListPage = observer(() => {
    const { category } = useBlogContext();
    const { trans } = useBlogTrans();

    const { title, description } = useMemo(() => {
        const categoryTitle = trans(category as keyof typeof trans);

        return {
            title: categoryTitle,
            description: `${trans('category')}: ${categoryTitle}`,
        };
    }, [category]);

    return (
        <Frame>
            <BlogMetaHeader title={title} description={description} />
            <BlogJsonld type="Blog" title={title} description={description} />
            <Frame.Title title={title} />
            <Box>
                <BlogPostList />
            </Box>
        </Frame>
    );
});

export default BlogPostListPage;
